import { FaqSection } from "./FaqSection";

import illustration from '../../images/eval-lp/illustration.svg';
import marketDataInputs from '../../images/eval-lp/market-data-inputs.svg';
import { useEffect } from "react";
import { user } from "../../user";
import { trackingService } from "../../services/action-tracking.service";

export const Eval = () => {
    useEffect(() => {
        const currentUser = user.current();

        if (!currentUser) return;

        trackingService.trackAction("Eval page has been opened", {
            userId: currentUser.id,
            userEmail: currentUser.email,
        });
    }, []);

    return (
        <div className="eval-lp">
            <div className="eval-lp-container">
                <div className="eval-head">
                    <div className="eval-head-content">
                        <h1>EVAL™</h1>
                        <p className="eval-head-info">Valuations, Simplified.</p>
                        <p className="eval-head-contact">
                            To get started, contact us at <br />
                            <a href="mailto:sales@kopentech.com">sales@kopentech.com</a>
                        </p>
                        
                        {/* <Link className="btn btn-main" to={routes.allBWICs}>
                            view k-talk
                        </Link> */}
                    </div>
                    <img src={illustration} alt="" />
                </div>

                <div className="eval-lp-section regtech-pricing-service">
                    <h2>Regtech Pricing Service</h2>
                    <p className="regtech-pricing-service-info">
                        Access full database of US BSL CLO securities priced in real-time and available via API (EUR & MM — coming soon)
                    </p>

                    <div className="regtech-pricing-service-row">
                        <div className="regtech-pricing-service-box">
                            <div className="regtech-pricing-service-col">
                                <h3>Real-Time Pricing</h3>
                                <p>Intraday pricing supported by live primary and secondary market events.</p>
                            </div>
                            <div className="regtech-pricing-service-col">
                                <h3>Multi-Model Approach</h3>
                                <p>Models combine machine learning and rules-based techniques.</p>
                            </div>
                            <div className="regtech-pricing-service-col">
                                <h3>Full Universe of CLO Securities</h3>
                                <p>Full-universe CLO pricing is available via API for deeper analysis and risk management modeling, complementing traditional security-level monthly pricing.</p>
                            </div>
                        </div>
                        <div className="regtech-pricing-service-box">
                            <div className="regtech-pricing-service-col">
                                <h3>Full Price Transparency</h3>
                                <p>Full detail on primary and secondary data used as inputs. Specific highlighted transactions that are viewed as comparable (based on structural features and collateral quality).</p>
                            </div>
                            <div className="regtech-pricing-service-col">
                                <h3>Price Visualization</h3>
                                <p>A three-dimensional surface (based on MVOC, DM and tenor) is provided for each CLO manager to help analyze future issuance.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="eval-lp-section market-data-input">
                    <div className="market-data-input-image">
                        <img src={marketDataInputs} alt="" />
                    </div>
                    <div className="market-data-input-content">
                        <div>
                            <h2>Market Data Inputs</h2>
                            <p>Datasets include but are not limited to:</p>
                            <ul>
                                <li>Secondary market color</li>
                                <li>Dealers’ price talk and inventory</li>
                                <li>Primary market insights</li>
                                <li>Structural and collateral details</li>
                                <li>Loan prices</li>
                                <li>Credit ratings</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="eval-lp-section methodology">
                    <h2>Methodology</h2>
                    <div className="methodology-row">
                        <div className="methodology-col">
                            <div className="methodology-index" data-number="1" />
                            <h3>Income-based approach</h3>
                            <p>
                                Future cash flows discounted to the net present value of the security.
                            </p>
                        </div>
                        <div className="methodology-col">
                            <div className="methodology-index" data-number="2" />
                            <h3>Multiple pricing factors</h3>
                            <p>
                                Model output is based on numerous deal and tranche characteristics, historical market dynamics, and intelligence gathered from market participants.
                            </p>
                        </div>
                        <div className="methodology-col">
                            <div className="methodology-index" data-number="3" />
                            <h3>Pricing of securities not traded in the secondary market</h3>
                            <p>
                                Since some U.S. CLO securities are infrequently traded, KopenTech applies a model-driven pricing approach using available market data and comparable analytics. While we strive for accuracy, prices reflect best efforts and are inherently subject to modeling assumptions.
                            </p>
                        </div>
                    </div>
                </div>

                <FaqSection />

                <div className="eval-lp-section free-trial">
                    <div className="free-trial-box">
                        <h2>Free Trial</h2>
                        <div className="free-trial-head">
                            <p>KopenTech is offering a <b>FREE TRIAL</b> of our CLO pricing service, EVAL™.</p>
                            <p>We currently provide daily pricing for the full universe of U.S. BSL securities, with EUR and MM coverage coming soon. For the trial, please limit your portfolio to 250 securities.</p>
                        </div>
                        <p className="free-trial-contact">To get started, contact us at <a href="mailto:sales@kopentech.com">sales@kopentech.com</a></p>
                    </div>
                </div>
            </div>
        </div>
    );
}
